module.exports = __webpack_public_path__ + "img/ve.0391c6e7.svg";